import { ReactElement } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import RegisterUserForm from '@/components/molecules/RegisterUserForm'
import SpecialSignUpCopy from '@/components/organisms/SpecialSignUpCopy'
import DefaultSignUpCopy from '@/components/organisms/DefaultSignUpCopy'
import { WithEmployerHeaderLayout } from '@/components/layouts'
import { targetUrl } from '@/helpers/url'
import CustomHead from '@/components/molecules/CustomHead'

interface IProps {
  header: boolean
}
export default function SignUpEmployer({ header = true }: IProps) {
  const { t } = useTranslation('common')
  const { data: session } = useSession()
  const router = useRouter()
  const { mode, target } = router.query
  const metaData = {
    title: t('common:register'),
    noindex: true,
  }
  if (session && session?.authToken?.includes('user')) {
    router.push({
      pathname: '/dashboard',
    })
    return <></>
  }

  const displayMode = () => {
    if (mode === 'special') {
      return 'special'
    }
    return 'default'
  }
  return (
    <>
      <CustomHead metaData={metaData} />
      <section className='bg-gray-bg min-h-screen'>
        <div className='container relative flex flex-row flex-wrap'>
          {displayMode() === 'special' ? (
            <SpecialSignUpCopy />
          ) : (
            <DefaultSignUpCopy />
          )}
          <div className='container-small xs:mb-20 pt-20'>
            <RegisterUserForm
              callbackUrl={targetUrl(target as string, '/dashboard', {
                newUser: 'true',
              })}
            />
          </div>
        </div>
      </section>
    </>
  )
}

SignUpEmployer.getLayout = function getLayout(page: ReactElement) {
  return (
    <WithEmployerHeaderLayout withFooter={false}>
      {page}
    </WithEmployerHeaderLayout>
  )
}
